export default __webpack_public_path__ + "media/zurb/img/icons/favicon/apple-touch-icon-57x57-0c131742defd0823650a733559e5dbae.png";